import Isotope from "isotope-layout";

class Grid {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-gallery="scope"]',
			grid: '[data-gallery="grid"]',
			filterBtn: '[data-gallery="filter"]'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((index, scope) => {
			let $scope = $(scope);
			let $grid = $scope.find(this.config.grid);
			let settings = Object.assign({
				itemSelector: '.gallery-column',
				layoutMode: 'fitRows'
			}, $grid.data())

			let isotope = new Isotope($grid[0], settings);

			this.addEventListeners($scope, isotope);
		})
	}

	addEventListeners($scope, isotope) {
		$scope.on('click', this.config.filterBtn, this.filter.bind(this, isotope));
	}

	filter(isotope, event) {
		event.preventDefault();
		let $button = $(event.currentTarget);
		let $scope = $button.closest(this.config.scope);

		isotope.arrange({
			filter: $button.attr('data-filter')
		});

		$scope.find(this.config.filterBtn).removeClass('active');
		$button.addClass('active');
	}
}

export default Grid;